import instance from "@/services/api";
import { buildingSettingsAPI } from "@/views/BuildingSettings/services/api";

export const materialLimitsAPI = {
  async getProjectTypes() {
    return await buildingSettingsAPI.getProjectTypes();
  },
  async getMaterialLimits(project_type_id) {
    if (!project_type_id) return;
    return await instance()
      .get("/handbook/project_type/materials/limit/read/", {
        params: { project_type_id },
      })
      .then((res) => res?.data);
  },
  async searchMaterials(data, signal) {
    return await instance()
      .post("/preset/preset_material/material/get/", data, { signal })
      .then((res) => res?.data);
  },
  async addMaterialLimit(project_type_id, body) {
    if (!project_type_id) return;
    const payload = { ...body, project_type_id };
    return await instance()
      .post("/handbook/project_type/materials/limit/modify/", payload, {
        params: { project_type_id },
      })
      .then((res) => res?.data);
  },
  async updateMaterialLimit(project_type_id, body) {
    if (!project_type_id) return;
    return await instance()
      .post("/handbook/project_type/materials/limit/modify/", body, {
        params: { project_type_id },
      })
      .then((res) => res?.data);
  },
  async deleteMaterialLimit(project_type_id, limit_id) {
    if (!project_type_id || !limit_id) return;
    return await instance()
      .delete(
        `/handbook/project_type/materials/limit/id/${limit_id}/delete/`,
        { params: { project_type_id } }
      )
      .then((res) => res?.data);
  },
};
